import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class ReqService {

  private apiUrl: string;

  constructor(
    private http: HttpClient) {
      this.apiUrl = environment.apiUrl;
  }

  static resolveUrl(url: string): string {
    if (url.indexOf('/') === 0) {
      return url.slice(0, url.length);
    }
    return url;
  }

  get(subUrl: string): Observable<any> {
    const url = ReqService.resolveUrl(subUrl);
    return this.http.get(`${this.apiUrl}/${url}`);
  }

  post(subUrl: string, data: object): Observable<any> {
    const url = ReqService.resolveUrl(subUrl);
    return this.http.post(`${this.apiUrl}/${url}`, data);
  }

  put(subUrl: string, data: object): Observable<any> {
    const url = ReqService.resolveUrl(subUrl);
    return this.http.put(`${this.apiUrl}/${url}`, data);
  }

  delete(subUrl: string): Observable<any> {
    const url = ReqService.resolveUrl(subUrl);
    return this.http.delete(`${this.apiUrl}/${url}`);
  }

}
